import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// Public
import JobListingSearchView from "../views/Public/JobListingSearchView.vue";
import JobListingSearchCategoriesView from "../views/Public/Content/JobListingCategories/JobListingSearchCategoriesView.vue";
import JobListingSearchCategoryView from "../views/Public/Content/JobListingCategories/JobListingSearchCategoryView.vue";
import JobListingView from "../views/Public/JobListing/JobListingView.vue";
import CompanySearchView from "../views/Public/Companies/CompanySearchView.vue";
import CompanyView from "../views/Public/Companies/CompanyView.vue";
// import CompanyRegisterView from "../views/Public/Authentication/Company/CompanyRegisterView.vue";
// import CompanyLoginView from "../views/Public/Authentication/Company/CompanyLoginView.vue";
// import CompanyResetPasswordView from "../views/Public/Authentication/Company/CompanyResetPasswordView.vue";
import ManageEmailSubscriptionView from "../views/Public/EmailSubscription/ManageEmailSubscriptionView.vue";
import ContactUsView from "../views/Public/Content/ContactUsView.vue";
import TokenView from "../views/Public/TokenView.vue";
import HireWithUsView from "../views/Public/Content/HireWithUsView.vue";
import PrivacyPolicyAndTermsView from "../views/Public/Content/PrivacyPolicyAndTermsView.vue";
import SiteMapView from "../views/Public/SiteMapView.vue";
import ArticlesView from "../views/Public/Content/Articles/ArticlesView.vue";
import ArticleView from "../views/Public/Content/Articles/ArticleView.vue";
import GetNotifiedView from "../views/Public/Content/GetNotifiedView.vue";
import NotFoundView from "../views/Public/NotFoundView.vue";
// Landing Pages
import LandingPage from "../views/Public/Content/LandingPages/LandingPage.vue";
// Company Account
// import CompanyDashboardView from "../views/CompanyAccount/CompanyDashboardView.vue";
// import CreateJobListingView from "../views/CompanyAccount/JobListing/CreateJobListingView.vue";
// import ManageJobListingView from "../views/CompanyAccount/JobListing/ManageJobListingView.vue";
// import CompanyManageView from "../views/CompanyAccount/Company/CompanyManageView.vue";
// import CompanyManageUsersView from "../views/CompanyAccount/Company/CompanyManageUsersView.vue";
// import CompanyInvoiceHistoryView from "../views/CompanyAccount/Company/CompanyInvoiceHistoryView.vue";
// import CompanySubscriptionView from "../views/CompanyAccount/Company/CompanySubscriptionView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: JobListingSearchView,
  },
  {
    path: "/job-skills",
    name: "jobSkills",
    component: JobListingSearchCategoriesView,
  },
  {
    path: "/job-skills/:category",
    name: "jobSkill",
    component: JobListingSearchCategoryView,
  },
  {
    path: "/hiring-companies/:companyname",
    name: "company",
    component: CompanyView,
  },
  {
    path: "/hiring-companies",
    name: "companies",
    component: CompanySearchView,
  },
  {
    path: "/hiring-companies/:companyname/:identifier",
    name: "jobListing",
    component: JobListingView,
  },
  {
    path: "/email-subscription/manage/:groupidentifier/",
    name: "manageEmailSubscription",
    component: ManageEmailSubscriptionView,
  }, 
  {
    path: "/contact-us",
    name: "contactUs",
    component: ContactUsView,
  }, 
  {
    path: "/token/:tokentype/:token",
    name: "token",
    component: TokenView,
  }, 
  // {
  //   path: "/hire-with-us/",
  //   name: "hireWithUs",
  //   component: HireWithUsView,
  // }, 
  {
    path: "/get-notified/",
    name: "getNotified",
    component: GetNotifiedView,
  }, 
  {
    path: "/policies",
    name: "policies",
    component: PrivacyPolicyAndTermsView,
  }, 
  {
    path: "/sitemap-html",
    name: "siteMap",
    component: SiteMapView,
  }, 
  {
    path: "/blog",
    name: "blogs",
    component: ArticlesView,
  }, 
  {
    path: "/blog/:resourceType",
    name: "blogResource",
    component: ArticlesView,
  }, 
  {
    path: "/blog/:resourceType/:slug",
    name: "blog",
    component: ArticleView,
  }, 
  {
    path: "/404",
    name: "notFoundView",
    component: NotFoundView,
  }, 
  {
    path: "/:slug",
    name: "landing-page",
    component: LandingPage,
  }, 
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: NotFoundView,
  }, 
];

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    // https://router.vuejs.org/guide/advanced/scroll-behavior
    //alert(to.path  + "  from"  + from.path)
    //alert(JSON.stringify(to))
    if (to.path == "" || to.path == "/"
    )
    {     
      if (
        from.path != "" && from.path !== String("/") 
      )
      {
            return { top: 0 }
      }
      return {
        //el: to.hash,
        //el: '#search',
      }    
    } 
    else { 
      return { top: 0 }
    }
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
